/** @jsx jsx */
import { jsx } from '@emotion/core';
import { FC, ReactNode } from 'react';
import { BoxProps } from 'rebass';
import { capitalCase } from 'change-case';
import { SelectOptions } from '../../components/cards/filtered-cards';
import Select from 'react-select';


interface FilterProps {
  className?: string;
  id?: string;
  children?: ReactNode;
  options?: any;
  updateFunction(value, indexNumber): void;
  selected?: SelectOptions[];
  indexNumber?: number;
  label?: string;

  css?: any;
}

const Filter: FC<FilterProps & JSX.IntrinsicElements['div'] & BoxProps> = ({
  className = '',
  id = '',
  children,
  options,
  updateFunction,
  selected,
  indexNumber,
  label,
  ...rest
}) => {
  return (
      <Select
        value={selected}
        onChange={value => updateFunction(value, indexNumber)}
        options={options}
        isMulti
        isSearchable
        placeholder={`${capitalCase(label)}`}
      />    
  );
};

export default Filter;
